// @flow

import { type State as ViewConfig } from 'app/common/redux/reducers/ui/views';
import { type Surface } from 'app/common/react/components/PinRep/core/PinRepConfiguration';

const surfaceToReduxStoreMap: { [Surface]: string } = {
  BaseBoardPinGrid: 'boardPinView',
  UserProfilePinGrid: 'profilePinView',
};

// Is the current grid surface in dense mode?
export default function getDenseViewState(viewConfig: ViewConfig, surface: Surface): boolean {
  const reduxStoreKey = surfaceToReduxStoreMap[surface];
  if (reduxStoreKey) {
    return viewConfig[reduxStoreKey] === 'dense';
  }

  return false;
}
